/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "uint160",
                name: "sqrtPrice_96",
                type: "uint160",
            },
        ],
        name: "getGasCostOfGetLogSqrtPriceFloor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
        ],
        name: "getGasCostOfGetSqrtPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint160",
                name: "sqrtPrice_96",
                type: "uint160",
            },
        ],
        name: "getLogSqrtPriceFU",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint160",
                name: "sqrtPrice_96",
                type: "uint160",
            },
        ],
        name: "getLogSqrtPriceFloor",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
        ],
        name: "getSqrtPrice",
        outputs: [
            {
                internalType: "uint160",
                name: "",
                type: "uint160",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class TestLogPowMath__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestLogPowMath__factory.bytecode = _bytecode;
TestLogPowMath__factory.abi = _abi;
